/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import input from "../../assets/styles/components/input.module.css";
import { getDocumentTypes } from "../../services/documentsManager";

interface SelectDocumentTypeProps {
  entidade:
    | "FINANCPAG"
    | "FINANCREC"
    | "EDUALUNO"
    | "RHCOLLAB"
    | "COMPRAS"
    | "FORNECEDOR"
    | "CUSTOMERS";
  handleChangeDocumentType: (e: string) => void;
  handleEntityFound?: (uidEntidade: string) => void;
  value: string;
}

const SelectDocumentType = ({
  entidade,
  handleChangeDocumentType,
  handleEntityFound,
  value,
}: SelectDocumentTypeProps) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["getDocumentTypes", entidade],
    queryFn: () => getDocumentTypes(entidade),
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (data && Array.isArray(data) && data.length > 0) {
      const uidEntidade =
        data[0]?.entidades_vinculadas?.[0]?.detalhes_entidade?.uid_entidade;

      if (uidEntidade && handleEntityFound) {
        handleEntityFound(uidEntidade);
      }
    }
  }, [data, handleEntityFound]);

  return (
    <label>
      Tipo de Documento
      <select
        className={input.input}
        value={value}
        onChange={(e) => handleChangeDocumentType(e.target.value)}
        disabled={isLoading}
      >
        <option value="">{isLoading ? "Carregando..." : ""}</option>

        {Array.isArray(data) &&
          data.map((doc: any) => (
            <option value={doc.uid_tipo_documento} key={doc.uid_tipo_documento}>
              {doc.titulo}
            </option>
          ))}
      </select>
      {error && (
        <span style={{ color: "red", fontSize: "12px" }}>
          Erro ao carregar tipos
        </span>
      )}
    </label>
  );
};

export default SelectDocumentType;
